import React, { useState } from 'react';
import { Col, Row, Switch } from 'antd';
import { useRefresh } from 'react-admin';
import { useController } from 'react-hook-form';

import { Credit } from '@types';
import { creditHttp } from '@network';
import { InitialCard, InitialRow, NumberSuffixInput } from '@components';
import cls from './credit-accredited.module.css';


interface Props {
  credit: Credit;
  editable?: boolean;
}

export const CreditAccredited = ({ credit, editable }: Props) => {
  const [loading, setLoading] = useState(false);
  const refresh = useRefresh();
  const {
    field: { value: isUsd, onChange: changeUsd },
  } = useController({ name: 'isUsd' });
  const {
    field: { onChange: changeExchangeRate },
  } = useController({ name: 'exchangeRate' });

  const isCompany = credit.accredited === 'company';

  const switchUsd = () => {
    if (!editable) return;
    const nextUsd = isUsd ? false : true;
    changeUsd(nextUsd);
    if (!nextUsd) changeExchangeRate(0);
  };

  const switchIsIndividual = async (isIndividual: boolean) => {
    if (!editable) return;
    const nextAccredited = isIndividual ? 'company' : 'individual';
    try {
      setLoading(true);
      await creditHttp.updateAccredited(credit.id, nextAccredited);
      refresh();
    } finally {
      setLoading(false);
    }
  };


  const switchIsUsd = async (isIndividual: boolean) => {
    const nextAccredited = isIndividual ? 'company' : 'individual';
    try {
      setLoading(true);
      await creditHttp.updateAccredited(credit.id, nextAccredited);
      refresh();
    } finally {
      setLoading(false);
    }
  };

  const switchClick = (_: boolean, e: any) => {
    if (loading) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const stopPropagation = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <Row gutter={[20, 20]}>
      <Col span={11}>
        <InitialCard autoHeight wrapperClass={cls.wrapper}>
          <InitialRow title="Client Type:" className={cls.row} labelCentered>
            <div className={cls.company}>
              <div className={cls.label}>PFAE</div>
              <div onClick={stopPropagation}>
                <Switch
                  defaultChecked={isCompany}
                  onClick={switchClick}
                  onChange={switchIsIndividual}
                  className={isCompany ? cls.companySwitchChecked : cls.companySwitch}
                  disabled={!editable}
                />
              </div>
              <div className={cls.label}>PM</div>
            </div>
          </InitialRow>
        </InitialCard>
      </Col>
      <Col span={13}>
        <InitialCard autoHeight wrapperClass={cls.wrapper}>
          <InitialRow title="Currency:" className={cls.row} labelCentered labelSize={6}>
            <div className={cls.currency}>
              <div className={cls.company}>
                <div className={cls.label}>MXN</div>
                <div onClick={stopPropagation}>
                  <Switch
                    defaultChecked={isUsd}
                    onClick={switchClick}
                    onChange={switchUsd}
                    className={isUsd ? cls.companySwitchChecked : cls.companySwitch}
                    disabled={!editable}
                  />
                </div>
                <div className={cls.label}>USD</div>
              </div>
              <NumberSuffixInput source="exchangeRate" suffix="$" fractional light
                min={0} max={99999999}
                helperText="Exch. Rate"
                className={cls.exchangeRate}
                disabled={!editable || !isUsd}
              />
            </div>
          </InitialRow>
        </InitialCard>
      </Col>
    </Row>
  );
};
